import { useState } from 'react';
import { IconEye, IconEyeOff } from './icons';

/** Ô nhập mật khẩu có nút mắt để ẩn/hiện. Nhận mọi thuộc tính của <input> (trừ type). */
export function PasswordInput(props: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const [shown, setShown] = useState(false);
  const label = shown ? 'Ẩn mật khẩu' : 'Hiện mật khẩu';
  return (
    <div className="pw-wrap">
      <input {...props} type={shown ? 'text' : 'password'} />
      <button type="button" className="pw-eye" onClick={() => setShown(s => !s)} aria-label={label} aria-pressed={shown} title={label}>
        {shown ? <IconEyeOff /> : <IconEye />}
      </button>
    </div>
  );
}
